import React, { useState } from "react";
import AlertMessage from "../../../partials/alertMessage";

const DateSearch = ({ fetch }) => {
	const [message, setMessage] = useState(null);
	const To = React.createRef();
	const From = React.createRef();

	return (
		<div className="card">
			<div className="card-head">
				<header>
					<i className="fa fa-filter" /> Filter
				</header>
				<div className="tools">
					<a
						className="t-collapse btn-color fa fa-chevron-down"
						href="javascript:;"
					></a>
				</div>
			</div>
			<div className="form-row card-body m-b-20">
				<div className="col-5">
					<label className="control-label">
						Date Range From
						<span className="required" aria-required="true">
							*
						</span>
					</label>
					<div className="">
						<input
							type="date"
							name="From"
							ref={From}
							data-required="1"
							className="form-control input-height"
						/>
					</div>
				</div>

				<div className="col-5">
					<label className="control-label">
						Date Range To
						<span className="required" aria-required="true">
							*
						</span>
					</label>
					<div className="">
						<input
							type="date"
							name="To"
							ref={To}
							data-required="1"
							className="form-control input-height"
						/>
					</div>
				</div>

				<div className="col text-center" style={{ marginTop: "2.5em" }}>
					<button
						type="button"
						className="mdl-button mdl-button--icon margin-right-10 btn-success"
						onClick={e => {
							e.preventDefault();
							const from = From.current.value;
							const to = To.current.value;
							if (from.length < 1 || to.length < 1) {
								setMessage("Please specify To and From respectively");
								return;
							}
							fetch({ from, to });
							setMessage(null);
						}}
					>
						<i className="material-icons">search</i>
					</button>
				</div>
			</div>
			{message && (
				<div className="card-footer">
					<AlertMessage message={message} failed={true} />
				</div>
			)}
		</div>
	);
};

export default DateSearch;
